import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4" data-testid="payment-cancel-page">
      <div className="max-w-md w-full bg-card border border-border rounded-md p-8 text-center">
        <AlertTriangle className="w-14 h-14 text-secondary mx-auto" />
        <h1 className="font-display font-extrabold text-3xl mt-4">Checkout cancelled</h1>
        <p className="text-muted-foreground mt-2">No worries — the listing is still available.</p>
        <Button onClick={() => navigate("/marketplace")} className="mt-6 bg-primary hover:bg-primary/90" data-testid="btn-back-marketplace">Back to marketplace</Button>
      </div>
    </div>
  );
}
